<template lang="pug">
    v-card.page-card
        v-card-text
            //- v-stepper.register-stepper(v-model="registerStep")
            //-     v-stepper-items
            //-         v-stepper-content(step="1")
            v-form(v-model="formValid" ref="registerform")
                //- v-alert.text-left(v-if="alertText != ''" outlined dense  type="error") {{alertText}}
                Alert
                v-text-field.page-input-field(v-model="email" solo dense outlined :rules="[rules.required, rules.email]" :placeholder="$t('Auth.__EnterEmail')" )
                v-text-field.page-input-field(v-model="password" solo dense outlined :rules="[rules.required, rules.password]" :placeholder="$t('Auth.__SetPassword')" :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'" @click:append="passwordShow = !passwordShow" :type="passwordShow ? 'text' : 'password'" @input="$refs.registerform.validate()")
                v-text-field.page-input-field(v-model="confirmedPassword" solo dense outlined :rules="[rules.required, confirmPassword]" :placeholder="$t('Auth.__ConfirmPassword')" type="password" )

                v-btn.page-btn.mb-6(block rounded color="primary" @click="register") {{$t('Auth.__Continue')}}
                    //- v-stepper-content(step="2")
                    //-     .alert-text 我們已寄送 Email 驗證信至下列信箱地址
                    //-     .alert-text.mb-6 請前往信箱收信，並點選啟用連結
                    //-     v-text-field.page-input-field(solo dense outlined readonly :value="email") 
                    //-     v-btn.page-btn.mb-6(block rounded color="primary" @click="resendEmail" :disabled="countdown!=0")  {{resendBtnTittle}}

            .text-or.text-center.mb-4 
                span {{$t('Auth.__Or')}}
            v-btn#google-btn.google-btn.mb-4(block rounded dark color="#4285f4") 
                v-avatar(left size="30" )
                    v-img(src="@/assets/images/icon-google.png")
                | {{$t('Auth.__ContinueWithGoogle')}}
            .text.mb-10 
                router-link(:to="'/'+$i18n.locale+'/login'") {{$t('Auth.__AlreadyHaveAccount')}}
            .text 
                i18n(path="Auth.__Agreement")
                    a.mr-2(href="https://www.2sumup.com/blank-1" target="_blank") {{$t('Auth.__TermsOfService')}}
                    a(href="https://www.2sumup.com/blank-2" target="_blank") {{$t('Auth.__PrivacyPolicy')}}

</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"
import * as googleAuth from "@/utils/googleAuth"

export default {
  data: () => ({
    formValid: false,
    rules: textfieldUtils.rules,
    passwordShow: false,
    email: "",
    password: "",
    confirmedPassword: "",
    registerStep: 1,
    alertText: "",
    resendBtnTittle: "",
    resendBtnTittle02: "重新寄送驗證信",
    countdown: 10,
    interval: null,
    signupObject: {}
  }),
  methods: {
    confirmPassword(value) {
      return this.password == value || this.$t("Form.__PasswordsMustBeSame")
    },
    register() {
      this.$refs.registerform.validate()
      if (this.formValid) {
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("auth/signup", {
            email: this.email,
            password: this.password
          })
          .then(
            function(response) {
              this.$store.dispatch("auth/updateToken", {
                token: response.data.accessToken
              })
              this.$router.push({
                name: "VerifyEmail",
                params: {
                  email: this.email
                }
              })
              this.$store.dispatch("global/stopLoading")
              // this.registerStep = 2
              // this.resendEmail()
              // this.startResendTimer()
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      }
    },
    loginByGoogle(token) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("auth/loginByGoogle", { token })
        .then(
          function(response) {
            this.loginSuccess(response.data.accessToken)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    loginSuccess(accessToken) {
      this.$store.dispatch("auth/updateToken", {
        token: accessToken
      })
      this.getMe()
    },
    getMe() {
      // this.getBiz()
      this.$store
        .dispatch("account/me")
        .then(
          function(response) {
            var user = response.data
            this.$store.dispatch("account/updateUser", response.data)
            if (user.isEmailVerified) {
              this.getBiz(response.data.lastlyUsedBusinessId)
            } else {
              this.$router.push({
                name: "VerifyEmail",
                params: {
                  email: user.email
                }
              })
              this.$store.dispatch("global/stopLoading")
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getBiz(bizId) {
      if (bizId != null) {
        this.$store
          .dispatch("bizes/getBiz", bizId)
          .then(
            function(response) {
              this.$store.dispatch("bizes/updateBizInfo", response.data)
              this.$router.push("/" + this.$i18n.locale + "/dashboard")
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      } else {
        this.$router.push("/" + this.$i18n.locale + "/business-info")
        this.$store.dispatch("global/stopLoading")
      }
    }
  },
  computed: {},
  mounted() {
    var vm = this
    googleAuth
      .getAuth2()
      .then(auth2 => {
        auth2.attachClickHandler(
          document.getElementById("google-btn"),
          {},
          function(googleUser) {
            vm.loginByGoogle(googleUser.getAuthResponse().id_token)
          },
          function(error) {}
        )
      })
      .catch(error => {
        // this.$store.dispatch("global/showAlert", {
        //     type: "error",
        //     message: "google auth fail"
        // })
      })

    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";

.register-stepper {
  box-shadow: 0 0 0 0;
  .v-stepper__content {
    padding: 0;
  }
}
</style>
